<app-loading-spinner *ngIf="appService?.raIsLoading"></app-loading-spinner>

<!-- <app-add-rate-table ></app-add-rate-table> -->
<app-add-dialog *ngIf="(operation ==='add'&& !isMatrixSelected)"></app-add-dialog>

<div class="overview-cls" *ngIf="(operation !=='add') || (operation === 'add' && isMatrixSelected)">
  <div class="agreement-form-area body-data">
    <div class="agreement-area">
      <form class="form" [formGroup]="rateTableForm">
  
        <table class="form-container" cellspacing="0" style="width: 75vw;">
          <tr>
            <div style="display: flex;justify-content: space-between;">
              <div class="title" style="display: flex;width: fit-content;text-transform: uppercase;">{{appService.rateTableList[appService.selectedItem] ?appService.rateTableList[appService.selectedItem].RateTableName:"Rate Table"}}</div>
              <div class="btn-right-area" style="display: inline-flex;align-items: center;margin-right: 10px;">
                <span style="cursor: pointer;color: #D40511;font-weight: 500;text-decoration: underline;" *ngIf="operation!=='view'" (click)="onDeleteRateTable()">
                  <mat-icon style="color: #D40511;position: relative;top: 8px;font-size: 21px;">delete</mat-icon>Delete Rate Table</span>
              </div>
          </div>
          </tr>
          <tr class="accord-area">
            <div class="input-item">
              <label for='rateTable' class='required-icon innerLabel'>Rate Table Name</label>
              <input type='text' name="rateTable" formControlName="rateTable" size='50' placeholder="Enter Rate Name" maxlength="200"
              tabindex="1" (change)="onFieldValue($event.target)"/>
            </div>
            <div class="input-item disable-field" (keydown)="onKeyDown($event)">
              <label for='rateTableType' class='required-icon innerLabel'>Rate Table Type</label>
              <select formControlName="rateTableType" (change)="onOptionChange($event.target,'rateTableType')" tabindex="-1">
                <option *ngFor="let option of rateTableTypeList" [value]="option.LookUpID">
                  {{ option.LookUpName }}
                </option>
              </select>
            </div>
            
            <div class="input-item">
              <label for='gsdb' class='required-icon innerLabel'>GSDB Site Code</label>
              <select formControlName="gsdb" name="gsdb" (click)="onSelctOption($event.target)" 
              (change)="onOptionChange($event.target,'gsdb')" tabindex="1">
                <option disabled value="">Select GSDB Site Code</option>
                <option *ngFor="let option of imscSideList" [value]="option">
                  {{ option }}
                </option>
              </select>
            </div>
  
            <div class="input-item">
              <label for='bpReference' class='required-icon innerLabel'>Bid Pack Reference</label>
              <select formControlName="bpReference" name="bpReference" (click)="onSelctOption($event.target)" 
              tabindex="1" (change)="onOptionChange($event.target,'bpReference')">
                <option disabled value="">Select Reference</option>
                <option *ngFor="let option of bidpackRefList" [value]="option.BidPackID">
                  {{ option.BidPackReference }}
                </option>
              </select>
            </div>
            
            <div class="input-item items-3 disable-field" (keydown)="onKeyDown($event)" >
              <label for='bpOriginRegion' class='required-icon innerLabel'>BP Origin Region</label>
              <input type='text' name="bpOriginRegion" formControlName="bpOriginRegion" size='50'
                placeholder="Enter BP Origin Region" tabindex="-1"/>
            </div>
            <div class="input-item disable-field" (keydown)="onKeyDown($event)">
              <label for='bpOriginPostcode' class='innerLabel'>BP Origin Region Postcode(Area)</label>
              <input type='text' name="bpOriginPostcode" formControlName="bpOriginPostcode" size='50'
                placeholder="Enter Name" tabindex="-1"/>
            </div>
            <div class="input-item disable-field" (keydown)="onKeyDown($event)">
              <label for='bpDestination' class='required-icon innerLabel'>BP Destination</label>
              <input type='text' name="bpDestination" formControlName="bpDestination" size='50'
                placeholder="Enter BP Destination" tabindex="-1"/>
            </div>
            <div class="input-item">
              <label for='transMode' class='required-icon innerLabel'>Transport Mode</label>
              <select formControlName="transMode" (change)="onOptionChange($event.target,'transMode')" tabindex="1">
                <option disabled value="">Select Mode</option>
                <option *ngFor="let option of transportModeList" [value]="option.LookUpID">
                  {{ option.LookUpName }}
                </option>
              </select>
            </div>
          </tr>
          <hr>
          <tr class="accord-area">
            <div class="input-item">
              <label for='fuelFlag' class='required-icon innerLabel'>Fuel Escalator Flag</label>
              <select formControlName="fuelFlag" (change)="onOptionChange($event.target,'fuelFlag')" tabindex="1">
                <option disabled value="">Select Flag</option>
                <option *ngFor="let option of ['Yes','No']" [value]="option">
                  {{ option }}
                </option>
              </select>
            </div>
  
            <div class="input-item" [ngClass]="this.fuelFlagSelected === 'Yes'?'enable-field':'disable-field'">
              <label for='excludingVat' class='innerLabel'  [ngClass]="this.fuelFlagSelected === 'Yes'?'required-icon':'remove-req-icon'">Excluding VAT</label>
              <select formControlName="excludingVat" (change)="onOptionChange($event.target,'excludingVat')" [tabindex]="this.fuelFlagSelected === 'Yes' ? 1 : -1">
                <option disabled value="">Select Excluding VAT</option>
                <option *ngFor="let option of ['Yes','No']" [value]="option">
                  {{ option }}
                </option>
              </select>
            </div>
  
  
            <div class="input-item" [ngClass]="this.fuelFlagSelected === 'Yes'?'enable-field':'disable-field'">
              <label for='fuelPrice' class='innerLabel'  [ngClass]="this.fuelFlagSelected === 'Yes'?'required-icon':'remove-req-icon'">Data Source For Fuel Price</label>
              <input type="text" [tabindex]="this.fuelFlagSelected === 'Yes' ? 1 : -1" formControlName="fuelPrice" name="fuelPrice" (change)="onFieldValue($event.target)">
            </div>


            <div class="input-item" [ngClass]="this.fuelFlagSelected === 'Yes'?'enable-field':'disable-field'">
              <label for='countryFuelPrice' class='innerLabel' [ngClass]="this.fuelFlagSelected === 'Yes'?'required-icon':'remove-req-icon'">Country For Fuel Price</label>
              <select formControlName="countryFuelPrice"  (click)="onSelctOption($event.target)" 
              (change)="onOptionChange($event.target,'countryFuelPrice')" [tabindex]="this.fuelFlagSelected === 'Yes' ? 1 : -1">
                <option disabled value="">Select Country</option>
                <option *ngFor="let option of countryListArr" [value]="option.CountryID">
                  {{ option.CountryName }}
                </option>
              </select>
            </div>

            <!-- <div class="input-item">
              <label for='countryFuelPrice' class='required-icon innerLabel'>Country For Fuel Price</label>
              <input type="number" formControlName="countryFuelPrice" name="countryFuelPrice" (change)="onFieldValue($event.target)">
            </div> -->
  
            <div class="input-item" [ngClass]="this.fuelFlagSelected === 'Yes'?'enable-field':'disable-field'">
              <label for='costBaseline' class='innerLabel' [ngClass]="this.fuelFlagSelected === 'Yes'?'required-icon':'remove-req-icon'">Fuel Cost Baseline(EUR)</label>
              <input type='number' name="costBaseline" formControlName="costBaseline" size='50'
                placeholder="Enter Fuel Cost Baseline" [tabindex]="this.fuelFlagSelected === 'Yes' ? 1 : -1" (change)="onFieldValue($event.target)"/>
            </div>
            <div class="input-item rate" [ngClass]="this.fuelFlagSelected === 'Yes'?'enable-field':'disable-field'">
              <label for='costBreakdown' class='innerLabel' [ngClass]="this.fuelFlagSelected === 'Yes'?'required-icon':'remove-req-icon'">Fuel Cost Breakdown(Cost Share)</label>
              <input type='number' name="costBreakdown" formControlName="costBreakdown" size='50'
                placeholder="Enter cost breakdown" [tabindex]="this.fuelFlagSelected === 'Yes' ? 1 : -1" (change)="onFieldValue($event.target)"/>
                <span class="percentage">%</span>
            </div>
            <div class="input-item rate" [ngClass]="this.fuelFlagSelected === 'Yes'?'enable-field':'disable-field'">
              <label for='fuelTrigger' class='innerLabel' [ngClass]="this.fuelFlagSelected === 'Yes'?'required-icon':'remove-req-icon'">Fuel Trigger</label>
              <input type='number' name="fuelTrigger" formControlName="fuelTrigger" size='50'
                placeholder="Enter Fuel Trigger"  [tabindex]="this.fuelFlagSelected === 'Yes' ? 1 : -1" (change)="onFieldValue($event.target)"/>
                <span class="percentage">%</span>
            </div>
            <div class="input-item"></div>
  
            <div class="input-item items-2" [ngClass]="this.fuelFlagSelected === 'Yes'?'enable-field':'disable-field'">
              <label for='version' class='required-icon'  [ngClass]="this.fuelFlagSelected === 'Yes'?'required-icon':'remove-req-icon'">Fuel Escalator Version</label>
              <!-- <textarea type='text' [tabindex]="this.fuelFlagSelected === 'Yes' ? 1 : -1" name="version" formControlName="version" (change)="onFieldValue($event.target)" ></textarea> -->
              <input type='text' [tabindex]="this.fuelFlagSelected === 'Yes' ? 1 : -1" name="version" formControlName="version" (change)="onFieldValue($event.target)" >
            </div>

            <div class="input-item items-2" [ngClass]="this.fuelFlagSelected === 'Yes'?'enable-field':'disable-field'">
              <label for='comment' >Fuel Escalator Comment</label>
              <input type='text' [tabindex]="this.fuelFlagSelected === 'Yes' ? 1 : -1" name="comment" formControlName="comment" maxlength="1024" (change)="onFieldValue($event.target)" >
            </div>
          </tr>
          <tr class="accord-area" style="display: flex;">
            <div >
              <label for='rateChange' class='title' style="font-size: 12px;left:3px;">Apply Rate Change</label>
                <div class="input-field rateConatiner"  [ngClass]="operation !=='view'?'enable-field':'disable-field'">
                  <div (click)="valueChange('minus')"><mat-icon class="mationc">remove</mat-icon></div>
                  <div id="rate"><input type='number' name="rateChange" id="rate" formControlName="rateChange" size='50'
                    placeholder=""  step="0.01" (input)="restrictFloatInput($event.target)" (blur)="appService.roundOffInput($event.target)"
                    (change)="onFieldValue($event.target)" tabindex="1"/>
                    <span class="percentage" style="left: 39px;">%</span></div>
                    
                  <div (click)="valueChange('add')"><mat-icon class="mationc">add</mat-icon></div>
                  </div>
                </div>
                <button class="btn white-red-btn" style="margin-top: 37px;max-width: 100px;height: 30px;" (click)="onSubmitChange()">Apply</button>
          </tr>
            <!-- <div class="form-container" style="width: 73vw;">
                <div class="title" style="font-weight: 500;">Fuel Escalator Comment</div>
                <div class="file-load-area" >
                   <img style="width: 25px;margin-bottom: 10px;" src="../../../../assets/images/upload-file-icon.png">
                   <ng-container *ngIf="!files || files?.length ===0"> 
                  <input type="file" [multiple]="false"  (change)="onFileSelected($event)"  style="display: none;"  #fileInput accept=".pdf,.docx,.doc,.xlsx,.xls,.ppt,.pptx,.csv,.txt,.png,.jpeg,.jpg"/>
                  <div class="browse-txt" (click)="fileInput.click()">Browse Files</div>
                  <span style="color: #666666; font-size: 12px;">*.pdf, *.docx, *.doc, *.xlsx, *.xls, *.ppt, *.pptx, *.csv, *.txt, *.png, *.jpeg, *.jpg </span>
                   <span style="color: #666666; font-size: 12px;"> up to 500 KB</span>
                  </ng-container>
                    <div *ngIf="files?.length > 0" class="file-list">
                      <div *ngFor="let file of files; let i = index" class="file-item" style="width: 60vw;">
                        <div class="file-area">
                          
                          <div style="display: flex;">
                            <mat-icon>description</mat-icon>
                            <span style="font-size: 12px;">{{ file.name }}</span>
                           
                          </div>
                          <span style="font-size: 10px;">{{file.size | filesize}}</span>
                        </div>
                        
                        <div class="icon-area">
                           <img src="../../../../assets/images/delete.png" *ngIf="operation!=='view'" style="cursor: pointer;"(click)="removeFile(i)" > 
                           <img src="../../../../assets/images/import-icon.png" style="cursor: pointer;"(click)="downloadFile(file)" > 
                        </div>
                      </div>
                    </div>
              </div>
            </div> -->
         
        </table>
      </form>
    </div>
  
    <div class="matrix-area" *ngIf="appService.rateTableList">
      <app-ftl-matrix *ngIf="appService.rateTableList[appService.selectedItem]?.RateTableTypeID === 42" [orderId]="appService.selectedItem" [rateId]="operation === 'add'?0:appService.rateTableList[appService.selectedItem].RateTableID" #ftlComp [operation]="operation" [name]="this.appService.rateDateSource[appService.selectedItem]?.RateTableName" ></app-ftl-matrix>
      <app-ltl-matrix *ngIf="appService.rateTableList[appService.selectedItem]?.RateTableTypeID === 44" [orderId]="appService.selectedItem" [rateId]="operation === 'add'?0:appService.rateTableList[appService.selectedItem].RateTableID" #ltlComp [operation]="operation" [name]="this.appService.rateDateSource[appService.selectedItem]?.RateTableName"></app-ltl-matrix>
      <app-fixed-ftl *ngIf="appService.rateTableList[appService.selectedItem]?.RateTableTypeID === 43" [orderId]="appService.selectedItem" [rateId]="operation === 'add'?0:appService.rateTableList[appService.selectedItem].RateTableID" #fixedComp [operation]="operation" [name]="this.appService.rateDateSource[appService.selectedItem]?.RateTableName"></app-fixed-ftl>
    </div>
  
    <div class="additional-area" *ngIf="appService.rateTableList">
      <app-additional-charges [hidden]="!shouldShowAdditionalCharges()" [rateId]="operation === 'add'?0:appService.rateTableList[appService.selectedItem]?.RateTableID"  [operation]="operation" [orderId]="appService.selectedItem" #additionComp></app-additional-charges>
    </div>
  
    <div class="agreement-area">
      <form class="form" [formGroup]="rateTableForm">
      <table class="form-container" cellspacing="0" style="width: 75vw;">
        <tr>
          <div class="title required-icon">Remarks</div>
        </tr>
        <tr>
          <div class="input-item items-4">
            <textarea type='text' maxlength="9000" tabindex="1" style="margin-bottom: 20px;" formControlName="remark" placeholder="Add remark here" name="remark" #remark 
            (change)="onFieldValue($event.target)"></textarea> <!-- (input)="remarksRemainingChars($event)"-->
            <!-- <small class="char-counter"  *ngIf="isRemarks"  style="display: block; text-align: right; margin-top: -45px;margin-right: 15px; color: #666;">
              {{remarksRemainingChar}} characters remaining
            </small> -->
          </div>
        </tr>
      </table>
    </form>
    </div>
  </div>
  
  <div class="menu-bar" style="width: 25vw;">
    <div class="toc-container no-print ng-star-inserted" style="max-height: 10320.3px;"><aio-lazy-ce
            selector="aio-toc"><aio-toc ng-version="17.1.0-next.5">
                <div class="toc-inner no-print collapsed ng-star-inserted">
                    <ul class="toc-list">
                        <li class="h1 menu-list ng-star-inserted" *ngFor="let i of appService.rateTableList; let ind=index"
                            [ngClass]="appService.selectedItem === ind?'highlighted':'dehighlighted'" id={{i.RateTableID}}><a
                                (click)="onListselection(ind)">{{i.RateTableName}}</a></li>
                    </ul>
                </div>
            </aio-toc></aio-lazy-ce></div>
            <button mat-button-primary class="btn white-red-btn" style="padding: 0px 5px" *ngIf="operation!=='view'"
                            (click)="onAddNewTable()"><mat-icon>add</mat-icon><span style="top: -7px;position: relative;">Add New Table</span></button>
  </div>
</div>
<!-- <app-export-pdf-table *ngIf="this.appService.rateDateSource[this.appService.selectedItem] && this.operation !='add' && appService.rateTableList[this.appService.selectedItem].RateTableTypeID === 42"  [data]="this.appService.rateDateSource?this.appService.rateDateSource[this.appService.selectedItem]:null"></app-export-pdf-table> -->
<!-- <app-export-pdf-fixed *ngIf="this.appService.rateDateSource[this.appService.selectedItem] && this.operation !='add' && appService.rateTableList[this.appService.selectedItem].RateTableTypeID === 43"  [data]="this.appService.rateDateSource?this.appService.rateDateSource[this.appService.selectedItem]:null"></app-export-pdf-fixed> -->
<!-- <app-export-pdf-ltl  *ngIf="this.appService.rateDateSource[this.appService.selectedItem] && this.operation !='add' && appService.rateTableList[this.appService.selectedItem].RateTableTypeID === 44"  [data]="this.appService.rateDateSource?this.appService.rateDateSource[this.appService.selectedItem]:null"></app-export-pdf-ltl> -->